(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('UsersController', UsersController);

  /* ngInject */
  function UsersController($filter, $stateParams, fiService, formErrorsService, sessionService, userService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.fiId = $stateParams.fiId;
    vm.fi = getFi();
    vm.users = getUsers();

    function getFi() {
      return fiService(sessionService.getAuthToken()).get({id: vm.fiId});
    }

    function getUsers() {
      return userService(sessionService.getAuthToken()).query({fiId: vm.fiId}, () => {
        vm.currentUser = $filter('orderBy')(vm.users, 'name')[0];
      });
    }
  }
})();
